'use strict';

angular.module('webAgro1App').service('ResumoOcorrenciasIndicadoresService', function($http, $q) {
  return {
    list: function(filters) {
      const url = `${SERVER + API_VERSION }ocorrencias/resumo_indicadores`;
      return $http.get(url, { params: filters });
    },

    getSummary: function(filters) {
      const deferred = $q.defer();

      this.list(filters).then(function(result) {
        const dados = result.data || {};
        (dados.ocorrencias || []).forEach(function(ocorrencia) {
          ocorrencia.indicadores.forEach(function(indicador) {
            if (indicador.tipo === 'valor') {
              indicador.media = indicador.summarize / dados.quantidade_pontos;
            } else if (indicador.tipo === 'percentual') {
              indicador.quantidade_pontos = dados.quantidade_pontos;
            }
          });
        });

        dados.cultivares = (dados.cultivares || []).filter(function(cultivar) {
          return cultivar.cultivar.descricao !== null;
        });

        deferred.resolve(dados);
      }, deferred.reject);

      return deferred.promise;
    }
  };
});
